import { Component, OnInit, AfterViewInit } from '@angular/core';
import { AuthService } from '../auth.service';
import { AppCommonService } from '../appcommon.service';

@Component({
  templateUrl: "./unauthorized.component.html"
})
export class UnauthorizedComponent implements OnInit, AfterViewInit {
  public pageTitle: string = 'Unauthorized';
  constructor(private authService: AuthService, private appCommonService: AppCommonService) {
    this.appCommonService.pageContentAdditionalClass = "";
    this.appCommonService.pageName = this.pageTitle;
  }
  ngOnInit() {

  }

  ngAfterViewInit() {

  }
}



// WEBPACK FOOTER //
// ./src/app/users/unauthorized.component.ts